<template>
<div v-if="data">
  <div class="container py-4">

    <!-- HEADER -->
    <div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4 gap-2">
      <h2 class="fw-bold text-primary mb-2 mb-md-0">
        <i class="bi bi-hospital"></i> Détails de l’hospitalisation
      </h2>

      <div class="d-flex flex-wrap gap-2">
       <div v-if="$store.getters.hasPermission('HOSP_IMPRESSION')" class="dropdown">
  <button class="btn btn-outline-primary dropdown-toggle" data-bs-toggle="dropdown" v-dropdown-fixed>
    <i class="bi bi-printer"></i> Imprimer
  </button>

  <ul class="dropdown-menu">
    <li>
      <a class="dropdown-item" @click="imprimerHospitalisationA4(data)">
        Format A4
      </a>
    </li>
    <li>
      <a class="dropdown-item" @click="imprimerHospitalisationTicketEpson(data)">
        Ticket 80 mm
      </a>
    </li>
     <li>
      <a class="dropdown-item" @click="imprimerHospitalisationTicket58(data)">
        Ticket 58mm
      </a>
    </li>
  </ul>
</div>

        <button
          v-if="(data && resteAPayer > 0) && data.statut !== 'Clôturée' && $store.getters.hasPermission('HOSP_PAIEMENT')"
          class="btn btn-warning"
          @click="ouvrirPaiement(data)"
        >
          <i class="bi bi-cash-stack"></i> Paiement
        </button>

        <demande-paiement-en-ligne
          v-if="data && data.id && resteAPayer > 0 && data.statut !== 'Clôturée' && $store.getters.hasModule('PAIEMENT_EN_LIGNE')"
          objet-type="HOSPITALISATION"
          :objet-id="data.id"
          taille=""
          libelle="Payer en ligne"
          @paye="loadDetails()"
        />

        <button
          v-if="data && data.statut !== 'Clôturée'  && $store.getters.hasPermission('HOSP_CLOTURE')"
          class="btn btn-success"
          @click="showModal = true"
        >
          <i class="bi bi-check2-circle"></i> Clôturer
        </button>

        <button
          v-if="data && data.statut === 'Clôturée' && $store.getters.hasPermission('HOSP_CLOTURE_ANNULE')"
          class="btn btn-danger"
          @click="annulerCloture"
        >
          <i class="bi bi-arrow-counterclockwise"></i> Annuler la clôture
        </button>

        <button class="btn btn-secondary" @click="$router.back()">
          <i class="bi bi-arrow-left"></i> Retour
        </button>
      </div>
    </div>

    <!-- CONTENU -->
    <div class="card shadow-sm p-4 content-print">

      <!-- MODAL CLOTURE -->
      <div v-if="showModal" class="modal-backdrop-custom">
        <div class="modal-custom">
          <h5 class="fw-bold">Clôturer l’hospitalisation</h5>

          <label class="mt-3">Date de sortie réelle :</label>
          <input type="date" v-model="dateSortieReelle" class="form-control" />

          <div class="mt-3 d-flex justify-content-end gap-2 flex-wrap">
            <button class="btn btn-secondary" @click="showModal = false">Annuler</button>
            <button class="btn btn-success" @click="cloturerHospitalisation">Valider</button>
          </div>
        </div>
      </div>

      <!-- PATIENT -->
      <h4 class="section-title"><i class="bi bi-person"></i> Informations Patient</h4>
      <div class="row mb-3">
        <div class="col-12 col-sm-6 col-md-4"><strong>Nom :</strong> {{ data.patient?.prenom }} {{ data.patient?.nom }}</div>
        <div class="col-12 col-sm-6 col-md-4"><strong>Dossier :</strong> {{ data.patient?.numeroDossier }}</div>
        <div class="col-12 col-sm-6 col-md-4"><strong>Téléphone :</strong> {{ data.patient?.telephone }}</div>
      </div>

      <hr />

      <!-- HOSPITALISATION -->
      <h4 class="section-title"><i class="bi bi-file-medical"></i> Hospitalisation</h4>
      <div class="row mb-3">
        
        <div class="col-12 col-sm-6 col-md-4"><strong>Date entrée :</strong> {{ formatDate(data.dateEntree) }}</div>
        <div class="col-12 col-sm-6 col-md-4"><strong>Sortie prévue :</strong> {{ formatDate(data.dateSortiePrevue) }}</div>
        <div class="col-12 col-sm-6 col-md-4">
          <strong>Sortie réelle :</strong>
          <span class="text-danger" v-if="!data.dateSortieReelle">En cours</span>
          <span v-else>{{ formatDate(data.dateSortieReelle) }}</span>
        </div>
        <div class="col-12 col-sm-6 col-md-4"><strong>Statut :</strong> {{ data.statut }}</div>
        <div class="col-12 col-sm-6 col-md-4"><strong>Num Hospitalisation :</strong> {{ data.numHospitalisation }}</div>
      </div>

      <hr />

      <!-- CHAMBRE -->
      <h4 class="section-title"><i class="bi bi-door-open"></i> Chambre & Lit</h4>
      <div class="row mb-3">
        <div class="col-12 col-sm-6 col-md-4"><strong>Chambre :</strong> {{ data.chambre?.numero || '—' }}</div>
        <div class="col-12 col-sm-6 col-md-4"><strong>Type :</strong> {{ data.chambre?.type?.nom || '—' }} — {{ data.chambre?.type?.tarifParJour || 0 }} F/jour</div>
        <div class="col-12 col-sm-6 col-md-4"><strong>Lit :</strong> {{ data.lit?.numero || '—' }}</div>
      </div>

      <hr />

      <!-- PAIEMENTS -->
      <h4 class="section-title"><i class="bi bi-cash-stack"></i> Paiements</h4>
      <div class="row g-2">

  <div class="col-12 col-sm-6 col-md-3">
    <strong>Montant calculé :</strong>
    {{ formatPrice(situation ? situation.montant : (data.montantCalcule?.montant || 0)) }} F
    <span v-if="situation" class="text-muted small">({{ situation.jours }} j × {{ formatPrice(situation.prixParJour) }} F{{ situation.provisoire ? ', provisoire' : '' }})</span>
  </div>

  <div class="col-12 col-sm-6 col-md-3 text-primary">
    <strong>Part patient :</strong>
    {{ formatPrice(situation ? situation.dejaPayePatient : (data.totalPartPatient || 0)) }} F
  </div>

  <div class="col-12 col-sm-6 col-md-3 text-success">
    <strong>Part assurance :</strong>
    {{ formatPrice(situation ? situation.dejaPrisEnChargeAssurance : (data.totalPartAssurance || 0)) }} F
  </div>

  <div class="col-12 col-sm-6 col-md-3">
    <strong>Total payé :</strong>
    {{ formatPrice(situation ? situation.dejaPaye : (data.totalPaye || 0)) }} F
  </div>

  <div class="col-12 col-sm-6 col-md-3 text-danger">
    <strong>Reste à payer :</strong>
    {{ formatPrice(resteAPayer) }} F
  </div>

  <div v-if="situation && situation.priseEnChargeSociale > 0" class="col-12 col-sm-6 col-md-3 text-info-emphasis">
    <strong>Offert par la clinique :</strong>
    {{ formatPrice(situation.priseEnChargeSociale) }} F
    <span v-if="social?.pourcentage" class="small text-muted">({{ social.pourcentage }} %{{ situation.provisoire ? ', suit le séjour' : '' }})</span>
  </div>

  <div
    class="col-12 col-sm-6 col-md-3 text-success"
    v-if="(situation ? situation.remboursement : data.remboursement) > 0"
  >
    <strong>Remboursement :</strong>
    {{ formatPrice(situation ? situation.remboursement : data.remboursement) }} F
  </div>

</div>

      <!-- Cas social : prise en charge par la clinique -->
      <div v-if="social" class="alert py-2 mt-3 small d-flex flex-wrap align-items-center gap-2" :class="social.statut === 'ACCORDEE' ? 'alert-info' : 'alert-warning'">
        <i class="bi bi-heart text-danger"></i>
        <span class="me-auto">
          <template v-if="social.statut === 'ACCORDEE'">Prise en charge sociale accordée par {{ social.traiteePar }} : {{ social.pourcentage ? social.pourcentage + ' % du séjour' : formatPrice(social.montant) + ' F' }} ({{ social.categorieLibelle }}).</template>
          <template v-else>Prise en charge sociale demandée par {{ social.demandeePar }} ({{ social.pourcentage ? social.pourcentage + ' %' : formatPrice(social.montant) + ' F' }}) : en attente d'accord.</template>
          <span class="text-muted"> {{ social.motif }}</span>
        </span>
        <button v-if="!data.dateSortieReelle && (socialDroits.peutAccorder || social.statut === 'DEMANDEE')" class="btn btn-sm btn-link text-warning py-0" @click="annulerSocial">{{ social.statut === 'DEMANDEE' ? 'Retirer la demande' : 'Annuler' }}</button>
      </div>
      <div v-else-if="peutDemanderSocial" class="text-end mt-2">
        <button class="btn btn-sm btn-outline-danger" @click="demanderSocial"><i class="bi bi-heart me-1"></i>Prise en charge sociale</button>
      </div>
      <prise-en-charge-sociale :cible="cibleSocial" :peut-accorder="socialDroits.peutAccorder" :resume="socialDroits.resume" @fermer="cibleSocial = null" @enregistre="apresSocial" />

      <!-- HISTORIQUE DES TRANSACTIONS -->
      <div class="card mt-4">
        <div class="card-header fw-bold bg-light">Historique des paiements</div>

        <div class="card-body p-0 table-responsive">
          <table class="table table-bordered mb-0">
            <thead class="table-primary">
              <tr>
                <th>Date</th>
                <th>Montant de base</th>
                <th>Montant Payé</th>
                <th>Assurance</th>
                <th>Taux</th>
                <th>Part Assurance</th>
                <th>Paiement Patient</th>
                
                <th>Type</th>
                <th>Enregistrer par</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!data.paiements || data.paiements.length === 0">
                <td colspan="10" class="text-center text-muted">Aucun paiement enregistré</td>
              </tr>
              <tr v-for="(p, index) in data.paiements" :key="p.id || index" :class="{ 'text-muted': p.statut && p.statut !== 'VALIDE' }">
  <td>{{ formatDateTime(p.datePaiement) }}
    <div class="small fw-semibold">{{ p.numero }}</div>
    <div v-if="p.statut && p.statut !== 'VALIDE'" class="small"><span class="badge bg-secondary">{{ p.statut === 'REMBOURSE' ? 'Remboursé' : 'Annulé' }}</span> {{ p.motifAnnulation }}</div>
  </td>

  <td>
    {{ formatPrice(p.montantBase || 0) }} F
  </td>

  <td class="fw-bold">
    {{ formatPrice(p.montant || 0) }} F
  </td>

  <td>
  {{ p.contratAssurance?.assurance?.nom || 'Aucune' }}
</td>
<td>
  {{
    p.contratAssurance?.tauxCouverture != null
      ? p.contratAssurance.tauxCouverture + '%'
      : '—'
  }}
</td>

<td class="text-success">
  {{ formatPrice(p.partAssurance || 0) }} F
</td>

<td class="text-primary">
  {{ formatPrice(p.partPatient || 0) }} F
</td>



  <td>
    <span class="badge bg-info">
      {{ p.type }}
    </span>
  </td>

  <td>
    {{ p.createdBy?.nom || p.userNom || '' }}
    {{ p.createdBy?.prenom || p.userPrenom || '' }}
  </td>

  <td>
    <div class="btn-group btn-group-sm">

      <button
        class="btn btn-outline-success"
        @click="imprimerPaiementHospitalisationA4(p, data)"
      >
        A4
      </button>

      <button
        class="btn btn-outline-dark"
        @click="imprimerPaiementHospitalisationTicketEpson(p, data)"
      >
        80mm
      </button>

      <button
        class="btn btn-outline-secondary"
        @click="imprimerPaiementHospitalisationTicket58(p, data)"
      >
        58mm
      </button>

      <button
        v-if="(!p.statut || p.statut === 'VALIDE') && !data.dateSortieReelle && $store.getters.hasAnyPermission(['PAIEMENT_ANNULER', 'PAIEMENT_REMBOURSER'])"
        class="btn btn-outline-danger"
        title="Annuler ou rembourser"
        @click="annulerPaiement(p)"
      >
        <i class="bi bi-x-circle"></i>
      </button>

    </div>
  </td>
</tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Feuille de suivi, constantes, changement de lit, compte-rendu de sortie -->
      <suivi-hospitalisation v-if="data && data.id" :hospitalisation-id="data.id" @change="loadDetails()" />

    </div>

    <!-- MODAL PAIEMENT -->
   <PaiementHospitalisationModal
  :visible="modalPaiementVisible"
  :hospitalisation="hospitalisationPourPaiement"
  :patientId="data?.patient?.id"
  @fermer="fermerPaiement"
  @paiementEffectue="onPaiementEffectue"
/>
  </div>
</div>

<div v-else-if="loadError" class="text-center my-5">
  <p class="text-danger fw-bold">Impossible de charger cette hospitalisation.</p>
  <button class="btn btn-outline-primary" @click="loadDetails">Réessayer</button>
</div>

<div v-else class="text-center my-5">
  <div class="spinner-border text-primary" style="width:50px;height:50px"></div>
  <p class="mt-2">Chargement en cours...</p>
</div>
</template>

<script>
import api, { messageErreur, notifier } from "@/api";
import { demanderMotif } from "@/components/commun/dialogue";
import { imprimer } from "@/impression/impression";
import {
  documentHospitalisationA4,
  documentHospitalisationTicket,
  documentRecuPaiementHospitalisationA4,
  documentRecuPaiementHospitalisationTicket,
} from "@/impression/documents/hospitalisation";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);
import PaiementHospitalisationModal from "@/components/PaiementHospitalisationModal.vue";
import DemandePaiementEnLigne from "@/components/paiement/DemandePaiementEnLigne.vue";
import SuiviHospitalisation from "@/components/hospitalisation/SuiviHospitalisation.vue";
import PriseEnChargeSociale, { prisesEnChargeDuPatient } from "@/components/social/PriseEnChargeSociale.vue";

export default {
  components: { PaiementHospitalisationModal, DemandePaiementEnLigne, SuiviHospitalisation, PriseEnChargeSociale },

  data() {
    return {
      data: null,
      loading: true,
      loadError: false,
      showModal: false,
      dateSortieReelle: dayjs().format('YYYY-MM-DD'),
      hospitalisationPourPaiement: null,
      modalPaiementVisible: false,
      // Situation financière calculée par le serveur
      situation: null,
      // Prise en charge sociale du séjour
      socialDroits: { hospitalisations: {}, peutAccorder: false, resume: null },
      cibleSocial: null,
    };
  },

  created() {
    this.loadDetails();
    
  },
  computed: {
    // Montants calculés par le serveur (GET hospitalisations/{id}/situation)
    social() {
      const p = this.data ? this.socialDroits.hospitalisations?.[this.data.id] : null;
      return p && ['DEMANDEE', 'ACCORDEE'].includes(p.statut) ? p : null;
    },
    peutDemanderSocial() {
      return !!this.data && !this.data.dateSortieReelle && !String(this.data.statut || '').toLowerCase().startsWith('annul')
        && this.$store.getters.hasAnyPermission(['SOCIAL_DEMANDER', 'SOCIAL_ACCORDER']);
    },
    resteAPayer() {
      return Number(this.situation ? this.situation.resteAPayer : (this.data?.resteAPayer || 0));
    },
  },

  methods: {
 formatDate(date) {
  if (!date) return "—";

  return dayjs(String(date).substring(0, 10)).format("DD-MM-YYYY");
},
    formatDateTime(date) {
  if (!date) return '—';

  // Heure locale de l'appareil : la plateforme s'utilise dans tous les fuseaux horaires
  return dayjs(date).format('DD-MM-YYYY HH:mm');
},
    formatPrice(value) { return new Intl.NumberFormat('fr-FR').format(value || 0); },

    async loadDetails() {
      this.loading = true;
      this.loadError = false;
      try {
        const res = await api.getItem("hospitalisations", this.$route.params.id);
        this.data = res.data;
        await Promise.all([this.chargerSituation(), this.chargerSocial()]);
      } catch (e) {
        console.error("Erreur chargement hospitalisation :", e);
        this.data = null;
        this.loadError = true;
      }
      finally { this.loading = false; }
    },

    /** Situation financière calculée par le serveur (dateSortie : aperçu avant clôture). */
    async chargerSituation(dateSortie = null) {
      const query = dateSortie ? `?dateSortie=${dateSortie}` : "";
      try {
        const res = await api.custom(`hospitalisations/${this.$route.params.id}/situation${query}`, "GET");
        if (!dateSortie) this.situation = res.data;
        return res.data;
      } catch (e) {
        console.error("Erreur chargement situation hospitalisation :", e);
        if (!dateSortie) this.situation = null;
        return null;
      }
    },
    async chargerSocial() {
      if (this.data?.patient?.id) this.socialDroits = await prisesEnChargeDuPatient(this.$store, this.data.patient.id);
    },
    demanderSocial() {
      this.cibleSocial = { type: 'hospitalisation', id: this.data.id, libelle: `Hospitalisation ${this.data.numHospitalisation || ''} (montant à ce jour, provisoire)`, montant: Number(this.situation?.montant || 0) };
    },
    async apresSocial() {
      this.cibleSocial = null;
      await Promise.all([this.chargerSituation(), this.chargerSocial()]);
    },
    async annulerSocial() {
      const p = this.social;
      const r = await demanderMotif({ titre: p.statut === 'DEMANDEE' ? 'Retirer la demande de prise en charge' : 'Annuler la prise en charge sociale', message: p.statut === 'DEMANDEE' ? '' : 'Le patient devra payer le séjour entier.', libelleValider: 'Confirmer' });
      if (!r) return;
      try {
        await api.post(`prises-en-charge-sociales/${p.id}/annuler`, { motif: r.motif });
        notifier('Prise en charge annulée.', 'success');
        await this.apresSocial();
      } catch (e) {
        notifier(messageErreur(e));
      }
    },
    ouvrirPaiement(hosp) {
      this.hospitalisationPourPaiement = { ...hosp, situation: this.situation };
      this.modalPaiementVisible = true;
    },
    fermerPaiement() {
      this.modalPaiementVisible = false;
      this.hospitalisationPourPaiement = null;
    },
  async effectuerPaiement(payload) {
  try {
    const res = await api.createItem(
      'paiement_hospitalisations',
      payload
    );

    const nouveauPaiement = res.data;

    if (nouveauPaiement) {
      if (!Array.isArray(this.data.paiements)) {
        this.data.paiements = [];
      }
      this.data.paiements.unshift(nouveauPaiement);
    }

    // Totaux et reste : rechargés depuis le serveur
    this.fermerPaiement();

    await this.loadDetails();

  } catch (e) {
    console.error(e);

    const message =
      e?.response?.data?.detail ||
      e?.response?.data?.message ||
      "Erreur lors du paiement.";

    alert(message);
  }
},
async onPaiementEffectue() {
  this.fermerPaiement();
  await this.loadDetails();
},
 
    async annulerCloture() {
      if (!confirm("Annuler la clôture ?")) return;
      try {
        await api.updateItem("hospitalisations", this.$route.params.id, {
          statut: "En cours",
          dateSortieReelle: null
        });
        await api.updateItem("lits", this.data.lit.id, { etat: "Occupé" });
        await this.loadDetails();
        alert("Clôture annulée.");
      } catch (e) {
        console.error("Erreur annulation clôture :", e);
        alert("Erreur.");
      }
    },
   async cloturerHospitalisation() {
  // Montant à la date de sortie choisie, calculé par le serveur
  const apercu = await this.chargerSituation(this.dateSortieReelle);
  if (apercu && apercu.resteAPayer > 0) {
    alert(`Paiement insuffisant ! Reste à payer : ${this.formatPrice(apercu.resteAPayer)} F (${apercu.jours} jour${apercu.jours > 1 ? 's' : ''}).`);
    return;
  }
  try {
    await api.custom(
      `hospitalisations/${this.$route.params.id}/cloturer`,
      "PATCH",
       {
         dateSortieReelle: this.dateSortieReelle
       }
    );

    this.showModal = false;
    await this.loadDetails(); 

  } catch (e) {
    console.error("Erreur clôture hospitalisation :", e);
    alert(e?.response?.data?.detail || e?.response?.data?.message || "Erreur lors de la clôture.");
  }
}
,

/** Paiements de l'hospitalisation (ceux déjà chargés avec elle ; annulés exclus de l'impression). */
async paiementsPourImpression(hospitalisation) {
  return (hospitalisation.paiements || []).filter(p => !p.statut || p.statut === 'VALIDE');
},
async annulerPaiement(p) {
  const r = await demanderMotif({
    titre: `Annuler l'encaissement ${p.numero || ''}`,
    message: "Si la caisse du jour est encore ouverte, l'encaissement est annulé. Sinon, le patient est remboursé depuis votre caisse (droit « Rembourser »).",
    libelleValider: "Annuler l'encaissement",
  });
  if (!r) return;
  try {
    const res = await api.post(`paiements/${p.id}/annuler`, { motif: r.motif });
    notifier(res.data?.message || 'Encaissement annulé.', 'success');
    await this.loadDetails();
  } catch (error) {
    notifier(messageErreur(error, "L'annulation a échoué."));
  }
},
async imprimerHospitalisationA4(hospitalisation) {
  if (!hospitalisation) return;
  const paiements = await this.paiementsPourImpression(hospitalisation);
  // Situation financière calculée par le serveur (paiements annulés exclus)
  const situation = (await this.chargerSituation()) || {};
  await imprimer(documentHospitalisationA4({ hospitalisation, paiements, situation, user: this.$store.getters.user }));
},
async imprimerHospitalisationTicketEpson(hospitalisation) {
  if (!hospitalisation) return;
  const paiements = await this.paiementsPourImpression(hospitalisation);
  const situation = (await this.chargerSituation()) || {};
  await imprimer(documentHospitalisationTicket({ hospitalisation, paiements, situation, user: this.$store.getters.user }));
},
async imprimerHospitalisationTicket58(hospitalisation) {
  // Même ticket que la version Epson (format ticket commun)
  return this.imprimerHospitalisationTicketEpson(hospitalisation);
},
async imprimerPaiementHospitalisationA4(paiement, hospitalisation) {
  if (!paiement || !hospitalisation) return;
  await imprimer(documentRecuPaiementHospitalisationA4({ paiement, hospitalisation, user: this.$store.getters.user }));
},
async imprimerPaiementHospitalisationTicketEpson(paiement, hospitalisation) {
  if (!paiement || !hospitalisation) return;
  await imprimer(documentRecuPaiementHospitalisationTicket({ paiement, hospitalisation, user: this.$store.getters.user }));
},
async imprimerPaiementHospitalisationTicket58(paiement, hospitalisation) {
  // Même ticket que la version Epson (format ticket commun)
  return this.imprimerPaiementHospitalisationTicketEpson(paiement, hospitalisation);
},
  }
};
</script>

<style scoped>
.section-title { font-weight: bold; color: #0d6efd; }

.modal-backdrop-custom {
  position: fixed; top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0,0,0,0.4);
  display: flex; align-items: center; justify-content: center; padding: 10px;
}
.modal-custom { background: white; width: 100%; max-width: 400px; padding: 20px; border-radius: 8px; }
.table-responsive { overflow-x: auto; }
</style>